/* eslint-disable */

export function dateKeyFromDate(value = new Date()) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

export function isDateWithinHoliday(dateKey, holiday) {
  if (!dateKey || !holiday) return false;

  const start = String(holiday.startDate || "");
  const end = String(holiday.endDate || holiday.startDate || "");

  return dateKey >= start && dateKey <= end;
}

export function getHolidayForDate(dateKey, holidays = []) {
  return holidays.find((h) => isDateWithinHoliday(dateKey, h)) || null;
}

export function isSchoolClosedOnDate(dateKey, holidays = []) {
  return !!getHolidayForDate(dateKey, holidays);
}

export function niceHolidayType(type) {
  const value = String(type || "").replaceAll("_", " ");
  return value.replace(/\b\w/g, (c) => c.toUpperCase());
}